import debounce from '../../util/debounce';
const OnePageHeader = {

    init() {
        this.jNavbar = $('.page__header');
        this.jScrollParent = $(window);
        this.currentScrollTop = 0;
        this.addEvents();
        this._checkAndAnimateHeader();

    },
    _onWindowResize: function() {
        if (window.innerWidth < 768) {
            $('.primary-nav__item-sub-menu').css('left', '');
        }
    },
    addEvents() {
        $('.jsPrimaryMenu .primary-nav__item').on('hover', $.proxy(this._onPrimaryMenuHover, this));
        $('.dropdown-menu').on('click', (e) => {
            e.stopPropagation();
        });
        $('.primary-nav__item-sub-menu-anchor').on('click',function(){
            var galleryUrl = $(this).attr('href'); 
            var str2 = '#gallery';
            if(galleryUrl.indexOf(str2) != -1){
                $('.gallery-top')[0].scrollIntoView({
                    behavior: 'smooth',
                });
            }
        });
        $(window).on('load',function(){
            var galleryUrl = document.URL;
            //alert(123);
            var str2 = '#gallery';
            if(galleryUrl.indexOf(str2) != -1){
                $('.gallery-top')[0].scrollIntoView({
                    behavior: 'smooth',
                });
            }
        });
        $(document).on('click', '.nav-link', function () {
			// e.preventDefault();
            let offset = 90;
            if($(this).attr('href') == '#overview'){
                let elementPosition = $('#overview').offset().top;
                let scrollPosition = elementPosition - offset;
                $('html, body').animate({scrollTop: scrollPosition}, 'smooth');
            }
            if($(this).attr('href') == '#location'){
                let elementPosition = $('#location').offset().top;
                let scrollPosition = elementPosition - offset;
                $('html, body').animate({scrollTop: scrollPosition}, 'smooth');
            }
            if($(this).attr('href') == '#experiences'){
                let elementPosition = $('#experiences').offset().top;
                let scrollPosition = elementPosition - offset;
                $('html, body').animate({scrollTop: scrollPosition}, 'smooth');
            }
            if($(this).attr('href') == '#rooms'){
                let elementPosition = $('#rooms').offset().top;
                let scrollPosition = elementPosition - offset;
                $('html, body').animate({scrollTop: scrollPosition}, 'smooth');
            }
            if($(this).attr('href') == '#dinning'){
                let elementPosition = $('#dinning').offset().top;
                let scrollPosition = elementPosition - offset;
                $('html, body').animate({scrollTop: scrollPosition}, 'smooth');
            }
            if($(this).attr('href') == '#gallery'){
                let elementPosition = $('#gallery').offset().top;
                let scrollPosition = elementPosition - offset;
                $('html, body').animate({scrollTop: scrollPosition}, 'smooth');
            }
            if($(this).attr('href') == '#facilities'){
                $('.hotel__facilities')[0].scrollIntoView({
                    behavior: 'smooth',
                });
            }
            // if($(this).attr('href') == '#gallery'){
            //     $('.gallery-top')[0].scrollIntoView({
            //         behavior: 'smooth',
            //     });
            // }

            if($(this).attr('href') == '#rooms-facilities'){
                $('.hotel__roomdetails-facilities')[0].scrollIntoView({
                    behavior: 'smooth',
                });
            }
            if($(this).attr('href') == '#other-rooms'){
                $('.hotel__otherrooms')[0].scrollIntoView({
                    behavior: 'smooth',
                });
            }
            
		
		});
        $(document).on('click', '.hotel__footernav-link-item', function (e) {
            e.preventDefault();
            if($(this).attr('href') == '#contact-us'){
                // e.preventDefault();
                $('.hotel__contactform')[0].scrollIntoView({
                    behavior: 'smooth',
                });
            }
        });
        this.addHeaderAutoHideEv();
        $(window).on('resize', debounce($.proxy(this._onWindowResize, this), 800));

        $('.page_temperature-scanner').on('click', $.proxy(this._onMenuItemClick, this));
    },
    addHeaderAutoHideEv() {
        this.jScrollParent.scroll(debounce($.proxy(this._checkAndAnimateHeader, this), 10));
    },
    _onMenuItemClick() {
         if (window.innerWidth > 768) {
            return;
         }
        // For Temperature scanner landing page
        // Todo : Improve this
         $('.page_temperature-scanner .navbar-collapse').collapse('hide');
    },
    _onPrimaryMenuHover(e) {

        if (window.innerWidth < 768) {
            return;
        }
        const jTarget = $(e.delegateTarget);
        const jSubmenu = jTarget.closest('.primary-nav__item').find('> .primary-nav__item-sub-menu');
        let maxWidth = 0; //this._jsCards.innerHeight();
        let jCurCol, jsCols = jSubmenu.find('.primary-nav__item-sub-menu-col');

        // Resize all the cols to same size
        for (let i = 0; i < jsCols.length; i++) {
            jCurCol = $(jsCols[i]);
            if (jCurCol.innerWidth() > maxWidth) {
                jCurCol.css('width', '');
                maxWidth = jCurCol.innerWidth();
            }
        }
        if (maxWidth == 0) {
            jsCols.css('width', '');
        } else {
            jsCols.css('width', maxWidth);
        }


        if (window.innerWidth < 1000) {
            jSubmenu.addClass('primary-nav__item-sub-menu_no-arrow');
            jSubmenu.css('left', 0);
        } else {
            jSubmenu.removeClass('primary-nav__item-sub-menu_no-arrow');
            jSubmenu.css('left', -(jSubmenu.innerWidth() / 2 - jTarget.width() / 2));
        }



    },
    _checkAndAnimateHeader() {
        const a = this.jScrollParent.scrollTop();
        this.currentScrollTop = a;
        if (this.currentScrollTop > 50) {
            this.jNavbar.addClass('page__header_up');
        } else {
            this.jNavbar.removeClass('page__header_up');
        }
        this.c = this.currentScrollTop;
    },
}
export default OnePageHeader;


// WEBPACK FOOTER //
// ./scripts/modules/components/_one-page-header.js